import React, { Component } from 'react'
import { connect } from 'react-redux'
import ContentLoader from '../../global/loaders/ContentLoader'
import DigitalProofingAndArtworkForm from '../DigitalProofingForms/DigitalProofingAndArtworkForm'

class BundleProofProduct extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedArtwork: null,
      selectedCoupon: null,
      selectedAddOn: null,
      formComplete: false,
      formData: {},
      proof1: false,
      proof2: false,
      productLoading: false
    }

    this.selectArtwork = this.selectArtwork.bind(this)
    this.selectCoupon = this.selectCoupon.bind(this)
    this.complete = this.complete.bind(this)
  }

  componentDidMount() {
    if (this.props.portal.managed_address_book) {
      let customerAddresses = []
      if (this.props.managed_customer_addresses && this.props.managed_customer_addresses.doors_hubs) {
        this.props.managed_customeraddresses.doors_hubs.map(address => {
          customerAddresses.push({
            title: address.name,
            full_name: '',
            address_line_1: address.address1,
            address_line_2: address.address2,
            city: address.city,
            state: address.state,
            zip_code: address.zip
          })
        })
      }
    }
  }

  selectArtwork(value) {
    this.setState({ selectedArtwork: value })
  }
  selectCoupon(value) {
    this.setState({ selectedCoupon: value })
  }
  selectAddon(value) {
    this.setState({ selectedAddOn: value })
  }

  handleCheckbox = name => event => {
    this.setState({ [name]: event.target.checked })
  }

  complete() {
    const artworkOverlayIds = [this.state.selectedCoupon, this.state.selectedAddOn].filter(
      id => id !== -1 && id !== null
    )

    this.props.complete(this.props.index, this.state.formData, this.state.selectedArtwork, artworkOverlayIds)
    this.setState({ formComplete: false })
  }

  render() {
    if (this.state.productLoading) {
      return <ContentLoader />
    }

    const { customerGroups, quantity, addProductToBasket } = this.props

    return (
      <div className="w-100">
        <div>
          <DigitalProofingAndArtworkForm
            isBundleProduct={true}
            product={this.props.product}
            customerGroups={customerGroups}
            quantity={quantity}
            addProductToBasket={addProductToBasket}
            selectedArtwork={this.state.selectedArtwork}
            setSelectedArtwork={this.selectArtwork}
            selectedCoupon={this.state.selectedCoupon}
            setSelectedCoupon={this.selectCoupon}
            collapseDpForm={this.props.collapseDpForm}
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    locations: state.storeViews.available,
    portal: state.portal,
    customer_addresses: Object.values(state.customer_addresses).filter(address => address.address_type === 'delivery'),
    mananged_customer_addresses: state.mananged_customer_addresses,
    currentLocation: state.storeViews.current,
    currentUser: state.currentUser
  }
}

export default connect(mapStateToProps)(BundleProofProduct)
